import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const vehicleBadgesSlice = createSlice({
	name: 'vehicleBadges',
	initialState,
	reducers: {
		vehicleBadgesSet(_state, action) {
			return action.payload;
		}
	}
});

export const { vehicleBadgesSet } = vehicleBadgesSlice.actions;

export default vehicleBadgesSlice.reducer;
